/**
 * @module linkage/chartTypeSwitch/reconcileForChartType/pipeLayers
 * @description 切图 L2 多层 reconcile 串行执行 + patch 累加
 */

import { type TChartType } from '@dbl/core/chart';
import type { QBStateSnapshot } from '../../../types';
import type { IReconcileLayerResult } from './reconcileTypes';

export type TReconcileLayerFn = (
  chartType: TChartType,
  qb: QBStateSnapshot,
  base: Record<string, unknown>,
  draft: Record<string, unknown>,
) => IReconcileLayerResult;

function mergeLayerResults(
  accumulated: IReconcileLayerResult,
  next: IReconcileLayerResult,
): IReconcileLayerResult {
  return {
    base: next.base,
    draft: next.draft,
    basePatch: { ...accumulated.basePatch, ...next.basePatch },
    draftPatch: { ...accumulated.draftPatch, ...next.draftPatch },
  };
}

/**
 * 按顺序执行各配置域 reconcile；每层基于上一层校正后的 base/draft，patch 累加。
 */
export function pipeReconcileLayers(
  chartType: TChartType,
  qb: QBStateSnapshot,
  base: Record<string, unknown>,
  draft: Record<string, unknown>,
  layers: TReconcileLayerFn[],
): IReconcileLayerResult {
  return layers.reduce<IReconcileLayerResult>(
    (acc, runLayer) => {
      const next = runLayer(chartType, qb, acc.base, acc.draft);
      return mergeLayerResults(acc, next);
    },
    { base, draft, basePatch: {}, draftPatch: {} },
  );
}

